export default {
  'entities.list.title': 'Entidades',
  'entities.admin.title': 'Gestionar Entidades',
  'entities.group.title': 'Adicionar Grupo de Entidad',

  'entities.form.title': 'Adicionar entidad',
  'entities.button.open': 'Abrir',
  'entities.button.builder': 'Configurar entidad',
  'entities.form.displayName': 'Nombre a Mostrar',
  'entities.form.displayPluralName': 'Nombre Plural',
  'entities.form.description': 'Descripción',
  'entities.form.order': 'Orden',
  'entities.form.type': 'Tipo',
  'entities.form.enabled': '¿Elemento Habilitado?',
  'entities.form.externalViewEnabled': '¿Vista Externa Habilitada?',
  'entities.form.entityGroup': 'Grupo de Entidad',

  'entity.prop.displayName': 'Nombre',
  'entity.prop.isRequired': 'Estado',
  'entity.prop.order': 'Orden',
  'entity.prop.type': 'Tipo',
  'entity.prop.options': 'Opciones',
  'entity.prop.name': 'Nombre',
  'entity.prop.token': 'Token',
  'entity.prop.permission': 'Permisos',
  'entity.prop.status': 'Estado',
  'entity.prop.description': 'Descripción',
  'entity.prop.user': 'Usuario',
  'entity.prop.entityType': 'Tipo',
  'entity.prop.dynamicEntityVersionNumber': 'Versión',
  'entity.prop.itemType': 'Tipo Elemento',
  'entity.prop.itemName': 'Nombre Elemento',
  'entity.prop.itemPropertyDisplay': 'Propiedad Elemento',
  'entity.prop.fieldDestinationDisplay': 'Campo Destino',
  'entity.prop.destinationReferenceDisplay': 'Referencia Destino',
  'entity.prop.destinationDynamicEntityDisplay': 'Entidad Destino ',
  'entity.prop.destinationDynamicEntityVersionNumber': 'Version Destino',
  'entity.prop.internalName': 'Nombre Interno',
  'entity.prop.created': 'Creado',
  'entity.prop.versionNumber': 'Numero de Version',
  'entity.prop.operation': 'Operacion',
  'entity.prop.creator': 'Author',
  'entity.prop.data': 'Datos',
  'entity.prop.number': 'Numero',
  'entity.prop.operationType': 'Tipo Operacion',
  'entity.prop.importance': 'Importancia',
  'entity.prop.scheduledDate': 'Fecha Programada',
  'entity.prop.observations': 'Observaciones',

  'entity.tab.configuration': 'Editar Entidad - {name}',
  'entity.tab.configurations': 'Configuraciones',
  'entity.tab.fields': 'Campos',
  'entity.tab.relations': 'Relaciones',
  'entity.tab.tokens': 'Tokens',
  'entity.tab.lists': 'Listas',
  'entity.tab.contributors': 'Colaboradores',
  'entity.tab.dependencies': 'Dependencias',
  'entity.tab.dependents': 'Dependientes',
  'entity.tab.traces': 'Trazas',
  'entity.tab.tasks': 'Tareas',
  'entity.tab.options': 'Opciones',

  'entity.accessMode1': 'Lectura',
  'entity.accessMode2': 'Escritura',

  'entity.text.showEntity': 'Mostrar Entidad',
  'entities.text.dynamicEntityGroups': 'Grupos de Entidades Dinámicas',

  'entity.field.text': 'Texto',
  'entity.field.textMultiple': 'Texto Múltiple',
  'entity.field.int': 'Número Entero',
  'entity.field.decimal': 'Número Decimal',
  'entity.field.boolean': 'Sí / No',
  'entity.field.date': 'Fecha',
  'entity.field.dateTime': 'Fecha y Hora',
  'entity.field.datetime': 'Fecha y hora',
  'entity.field.time': 'Hora',
  'entity.field.choice': 'Elección',
  'entity.field.dataBaseRemoteSearch': ' Búsqueda Remota - Base de Datos',
  'entity.field.dataBaseRemoteList': 'Lista Remota - Base de Datos',
  'entity.field.webServiceRemoteSearch': 'Búsqueda Remota - Servicio web',
  'entity.field.webServiceRemoteList': 'Lista Remota - Servicio Web',
  'entity.field.fieldDynamicEntityList': 'Lista - Entidad Dinámica',
  'entity.field.selectorUser': 'Selector Usuario',
  'entity.field.selectorPosition': 'Selector Puesto',
  'entity.field.selectorUserGroup': 'Selector Grupos de Usuarios',
  'entity.field.table': 'Tabla',
  'entity.field.attachment': 'Archivo adjunto',
  'entity.field.areaSelector': 'Selector de Área',
  'entity.field.autoCalculatedByTableColumn': 'Auto-calculado por columna de la tabla',
  'entity.field.fieldDynamicEntity': 'Campo de Entidad Dinámica',
  'entity.field.calculatedByFormula': 'Calculado por fórmula',
  'entity.field.image': 'Imagen',
  'entity.field.photo': 'Foto',
  'entity.field.signature': 'Firma',
  'entity.field.goToAction': 'Acción',
  'entity.field.slider': 'Deslizador',
  'entity.field.selectorArea': 'Selector de Área',
  'entity.field.radioGroup': 'Grupo de Radio',
  'entity.field.checkGroup': 'Grupo de Casillas',
  'entity.field.url': 'URL',
  'entity.field.email': 'Correo Electrónico',
  'entity.field.location': 'Ubicación',
  'entity.field.password': 'Contraseña',
  'entity.field.fieldDynamicEntitySearch': 'Búsqueda - Entidad Dinámica',

  'entity.field.status.required': 'Requeridos',
  'entity.field.status.notRequired': 'No Requeridos',

  'entity.attr.allowedExtensions': 'Extensiones Permitidas',
  'entity.attr.allowInsertNewOption': '¿Permitir Insertar Nueva Opción?',
  'entity.attr.allowMultiple': '¿Permitir Múltiples?',
  'entity.attr.autoSelect': '¿Auto-seleccionar?',
  'entity.attr.autoSelectAll': 'Seleccionar Todo Automáticamente',
  'entity.attr.choices': 'Opciones',
  'entity.attr.codeProperty': 'Propiedad Código',
  'entity.attr.columnWidth': 'Tamaño de Columna',
  'entity.attr.connection': 'Conexión',
  'entity.attr.currentDateDefaultValueEnabled': 'Habilitar Valor Predeterminado de Fecha Actual',
  'entity.attr.currentDateTimeDefaultValueEnabled':
    'Habilitar Valor Predeterminado de Fecha y Hora Actual',
  'entity.attr.currentTimeDefaultValueEnabled': 'Habilitar Valor Predeterminado de Hora Actual',
  'entity.attr.currentUser': 'Usuario Actual por Defecto',
  'entity.attr.currentUserArea': 'Área del Usuario Actual',
  'entity.attr.currentUserPosition': 'Posición del Usuario Actual por Defecto',
  'entity.attr.currentUserUserGroups': 'Grupos del Usuario Actual por Defecto',
  'entity.attr.databaseQueryId': 'Consulta',
  'entity.attr.decimalPlaces': 'Decimales',
  'entity.attr.defaultValue': 'Valor Predeterminado',
  'entity.attr.destinationFolder': 'Carpeta de Destino',
  'entity.attr.destinationFolderId': 'Carpeta de Destino',
  'entity.attr.displayText': 'Texto a Mostrar',
  'entity.attr.displayTextDynamicEntityField': 'Campo de Texto a Mostrar',
  'entity.attr.displayTextProperty': 'Propiedad Texto a Mostrar',
  'entity.attr.dynamicEntity': 'Entidad Dinámica',
  'entity.attr.dynamicEntityId': 'Entidad Dinámica',
  'entity.attr.enabled': 'Habilitado',
  'entity.attr.extraLarge': 'Extra Grande',
  'entity.attr.filters': 'Filtros',
  'entity.attr.format': 'Formato',
  'entity.attr.formula': 'Formula',
  'entity.attr.groupingType': 'Tipo de Agrupación',
  'entity.attr.id': 'ID',
  'entity.attr.isActive': '¿Elemento Habilitado?',
  'entity.attr.isCurrentDateDefaultValue': '¿Fecha Actual Por Defecto?',
  'entity.attr.isCurrentTimeDefaultValue': '¿Hora Actual Por Defecto?',
  'entity.attr.isCurrentUserLocationEnabled': '¿Habilitar Ubicación del Usuario Actual?',
  'entity.attr.isMaxIntValueEnabled': '¿Habilitar Control Valor Máximo?',
  'entity.attr.isMaxLengthEnabled': '¿Habilitar Longitud Máxima?',
  'entity.attr.isMaxSelectionsAllowed': '¿Habilitar Control Selecciones Máximas?',
  'entity.attr.isMaxSelectionsAllowedEnabled': '¿Habilitar Control Selecciones Máximas?',
  'entity.attr.isMinIntValueEnabled': '¿Habilitar Control Valor Mínimo?',
  'entity.attr.isMinSelectionsRequired': '¿Habilitar Control Selecciones Mínimas?',
  'entity.attr.isMinSelectionsRequiredEnabled': '¿Habilitar Control Selecciones Mínimas?',
  'entity.attr.isRegularExpressionValidationEnabled':
    '¿Habilitar Validación por Expresión Regular?',
  'entity.attr.isRequired': '¿Requerido?',
  'entity.attr.isUniqueValueValidationEnabled': '¿Validación Valor Único Habilitada?',
  'entity.attr.isVisibleInManagementTable': '¿Visible en Tabla de Gestión?',
  'entity.attr.visibleInManagement': '¿Visible en Tabla de Gestión?',
  'entity.attr.isVisibleInDetails': '¿Visible en Detalles?',
  'entity.attr.key': 'Clave',
  'entity.attr.large': 'Grande',
  'entity.attr.maxAttachmentsAllowed': 'Máximo de Archivos Adjuntos Permitidos',
  'entity.attr.maxDecimalValue': 'Cantidad de Decimales Permitidos',
  'entity.attr.maxFileSize': 'Tamaño Máximo de Archivo',
  'entity.attr.maxHeightRequired': 'Altura Máxima Requerida',
  'entity.attr.maxIntValue': 'Valor Máximo',
  'entity.attr.maxLength': 'Longitud Máxima',
  'entity.attr.maxSelectionsAllowed': 'Selecciones Máximas Permitidas',
  'entity.attr.maxValue': 'Valor Máximo',
  'entity.attr.maxValueFieldId': 'Campo de Valor Máximo',
  'entity.attr.maxWidthRequired': 'Ancho Máximo Requerido',
  'entity.attr.medium': 'Mediano',
  'entity.attr.minAttachmentsRequired': 'Mínimo de Archivos Adjuntos Requeridos',
  'entity.attr.minHeightRequired': 'Altura Mínima Requerida',
  'entity.attr.minIntValue': 'Valor Mínimo',
  'entity.attr.minLength': 'Longitud Mínima',
  'entity.attr.minValue': 'Valor Mínimo',
  'entity.attr.minSelectionsRequired': 'Selecciones Mínimas Requeridas',
  'entity.attr.minValueFieldId': 'Campo de Valor Mínimo',
  'entity.attr.minWidthRequired': 'Ancho Mínimo Requerido',
  'entity.attr.modifier': 'Modificador',
  'entity.attr.observations': 'Observaciones',
  'entity.attr.order': 'Orden',
  'entity.attr.orderByDynamicEntityField': 'Campo de Ordenamiento',
  'entity.attr.orderDirection': 'Dirección de Ordenamiento',
  'entity.attr.regularExpression': 'Expresión Regular',
  'entity.attr.relatedDynamicEntityFieldId': 'Campo Relacionado',
  'entity.attr.relatedDynamicEntityFieldValueId': 'Valor Campo Relacionado',
  'entity.attr.relatedDynamicEntityId': 'Entidad Dinámica Relacionada',
  'entity.attr.required': 'Requerido',
  'entity.attr.scannerEnabled': '¿Escáner Habilitado?',
  'entity.attr.searchParameterName': 'Nombre del Parámetro de Búsqueda',
  'entity.attr.searchValueProperty': 'Propiedad Valor de Búsqueda',
  'entity.attr.small': 'Pequeño',
  'entity.attr.textFormat': 'Formato de Texto',
  'entity.attr.type': 'Tipo',
  'entity.attr.updated': 'Actualizado',
  'entity.attr.userDisplayValue': 'Valor de Visualización del Usuario',
  'entity.attr.userExtraField': 'Campo Extra del Usuario',
  'entity.attr.valueDynamicEntityField': 'Campo de Valor',
  'entity.attr.webApiConnectionId': 'Conexión API',
  'entity.attr.internalName': 'Nombre Interno',
  'entity.attr.visibleInDetails': 'Visible en Detalles',
  'entity.attr.creator': 'Creador',
  'entity.attr.created': 'Creado',
  'entity.attr.minValueField': 'Campo de Valor Mínimo',
  'entity.attr.maxValueField': 'Campo de Valor Máximo',
  'entity.attr.userCreator': 'Usuario Creador',
  'entity.attr.userModifier': 'Usuario Modificador',

  'entity.extension.jpg': 'Imagen JPG',
  'entity.extension.jpeg': 'Imagen JPEG',
  'entity.extension.png': 'Imagen PNG',
  'entity.extension.gif': 'Imagen GIF',
  'entity.extension.bmp': 'Imagen BMP',
  'entity.extension.svg': 'Imagen SVG',
  'entity.extension.webp': 'Imagen WebP',
  'entity.extension.ico': 'Ícono ICO',
  'entity.extension.tiff': 'Imagen TIFF',
  'entity.extension.tif': 'Imagen TIF',
  'entity.extension.pdf': 'Documento PDF',
  'entity.extension.doc': 'Documento Word',
  'entity.extension.docx': 'Documento Word (DOCX)',
  'entity.extension.xls': 'Hoja de Cálculo Excel',
  'entity.extension.xlsx': 'Hoja de Cálculo Excel (XLSX)',
  'entity.extension.txt': 'Archivo de Texto',
  'entity.extension.csv': 'Archivo CSV',

  'entity.token.name': 'Nombre',
  'entity.token.add': 'Adicionar Token',
  'entity.token.detail': 'Token Detalles',
  'entity.token.isReadEnabled': '¿Lectura Habilitada?',
  'entity.token.isWriteEnabled': '¿Escritura Habilitada?',
  'entity.token.isDeleteEnabled': '¿Eliminación Habilitada?',
  'entity.token.isActive': '¿Elemento Habilitado?',
  'entity.token.read': 'Lectura',
  'entity.token.write': 'Escritura',
  'entity.token.delete': 'Eliminar',
  'entity.token.url': 'Documentación',

  'entity.list.add': 'Adicionar Lista',
  'entity.list.edit': 'Editar Lista',
  'entity.list.detail': 'Detalle de Lista',
  'entity.list.group': 'Grupo de Listas',
  'entity.list.type': 'Tipo',
  'entity.list.formMode': 'Modo de Edición',
  'entity.list.type.taskBoard': 'Tablero de Tareas',
  'entity.list.type.cardsList': 'Lista de Tarjetas',
  'entity.list.type.mapList': 'Lista en Mapa',

  'dynamicEntities.title': 'Gestionar - {name}',
  'dynamicEntities.userGroup': 'Grupo de Usuarios',
  'dynamicEntities.userGroupExists': 'Grupo de Usuario existe',
  'dynamicEntities.title.detail': 'Detalles',

  'dynamicEntities.form.email': 'Correo Electrónico',
  'dynamicEntities.form.names': 'Nombres',
  'dynamicEntities.form.lastNames': 'Apellidos',
  'dynamicEntities.form.role': 'Rol',
  'dynamicEntities.form.positionId': 'Puesto',
  'dynamicEntities.form.userBossId': 'Jefe',
  'dynamicEntities.form.accessType': 'Tipo de Acceso',
  'dynamicEntities.form.isActive': 'Habilitar',

  'dynamicEntities.form.selectGroup': 'Selecciona un grupo',
  'dynamicEntities.form.selectUser': 'Selecciona un usuario',
  'dynamicEntities.mixed': 'Mixto',
  'dynamicEntities.usernameAndPassword': 'Usuario y contraseña',
  'dynamicEntities.office365': 'Office365',

  'entity.referenceSourceEntityType1': 'Entidad',
  'entity.referenceSourceEntityType2': 'Proceso',
  'entity.referenceSourceEntityType3': 'Lista Personalizada',

  'entity.referenceSourceItemType1': 'Campo de Entidad',
  'entity.referenceSourceItemType2': 'Campo de Formulario',
  'entity.referenceSourceItemType3': 'Acción',
  'entity.referenceSourceItemType4': 'Campo de Lista',
  'entity.referenceSourceItemType5': 'Proceso',

  'entity.purge.confirm.title': '¡ATENCIÓN!',
  'entity.purge.confirm.body.before':
    'Estas a punto de eliminar toda la información de la entidad. Tenga presente que esta operación',
  'entity.purge.confirm.body.emphasis': 'es permanente y no tiene revisión',
  'entity.purge.confirm.body.after': 'y al confirmar, todos los datos se perderán.',
  'entity.purge.confirm.question': '¿Seguro de querer borrar todos los datos?',

  'entity.notification.purge.success':
    'Todos los datos de la entidad han sido eliminados satisfactoriamente.',
};
